import React from 'react';

function UnresponsiveKickList({ players, isHost, onKickPlayer }) {
  if (!isHost || !onKickPlayer) return null;
  const targets = (players || []).filter(p => p.unresponsive);
  if (targets.length === 0) return null;
  return (
    <div className="kick-list" role="region" aria-label="Unresponsive players">
      {targets.map(p => (
        <div key={p.id} className="kick-list-row">
          <span className="kick-list-icon material-symbols-outlined">cloud_off</span>
          <span className="kick-list-text">
            <strong>{p.name}</strong> hasn't responded.
          </span>
          <button
            type="button"
            className="kick-btn"
            onClick={() => onKickPlayer(p.id)}
            title={`Remove ${p.name} from the game`}
          >
            <span className="material-symbols-outlined kick-btn-icon">logout</span>
            Boot
          </button>
        </div>
      ))}
    </div>
  );
}

export default UnresponsiveKickList;
